var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "select-box"
  }, [_c('el-select', {
    directives: [{
      name: "no-emoji",
      rawName: "v-no-emoji"
    }],
    attrs: {
      "disabled": _vm.disabled,
      "clearable": _vm.clearable,
      "placeholder": _vm.placeholder,
      "filterable": _vm.filterable,
      "popper-append-to-body": _vm.appendBody
    },
    on: {
      "change": _vm.change,
      "visible-change": _vm.visibleChange
    },
    model: {
      value: _vm.val,
      callback: function ($$v) {
        _vm.val = $$v;
      },
      expression: "val"
    }
  }, _vm._l(_vm.data, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.noTranslate ? item.label : _vm.$t(`lang.${item.label}`),
        "value": item.value,
        "disabled": item.disabled
      }
    });
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }